import React from 'react'
import Usersearch from '../components/users/Usersearch'
import Userresults from '../components/users/Userresults'

const Home = () => {

   
  return (
    <>
        <Usersearch/>
        <Userresults/>
    </>
  )
}

export default Home